import './popupwindow.css';
import {ref} from 'vue'

export const PopupWindow = {
    props: {
        // Пропсы компонента
        positionLeft: {
            type: String,
            required: false,
        },
        positionTop: {
            type: String,
            required: false,
        },
    },

    data() {
        return {
            // Локальные данные компонента
            popupRef: null,
            eventAdded: false,

        };
    },

    computed: {
        // Вычисляемые свойства
    },

    methods: {
        // Методы компонента
        handleClickOutside(event) {
            if (this.popupRef && !this.popupRef.contains(event.target)) {
                this.$emit('close');
            }
        },
    },

    watch: {
        // Наблюдатели за изменением значений
    },

    mounted() {
        // Логика, выполняемая при монтировании компонента
        setTimeout(() => {
            if (!this.eventAdded) {
                document.addEventListener('click', (event) => this.handleClickOutside(event))
                this.eventAdded = true;
            }
        }, 0);
    },

    beforeUnmount() {
        // Логика, выполняемая после размонтирования компонента
        if (this.eventAdded) {
            document.removeEventListener('click', (event) => this.handleClickOutside(event))
            this.eventAdded = false;
        }
    },

    // language=Vue
    template: `
      <div class="ymap-popup_container" :ref="(el)=>{popupRef=el}">
        <div class="ymap-popup_content">
          <slot></slot>
        </div>
      </div>
    `
};